import { FormFieldState } from '@/common/form/FormFieldState';
import { FormStateBase } from '@/common/form';

export class RegistrationsDetailsFormStateCustomer extends FormStateBase {
    name: FormFieldState = new FormFieldState();
    phone: FormFieldState = new FormFieldState();
    tenantName: FormFieldState = new FormFieldState();

    constructor() {
        super();
        this.setForm(this);
    }
}
